import { useMutation, useQueryClient } from '@tanstack/react-query';
import { assignUnassignMemberNumber } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useAssignUnassignMemberNumber({
  onSuccessFn = () => null,
  onErrorFn = () => null,
} = {}) {
  const queryclient = useQueryClient();
  const Request = useMutation({
    mutationFn: assignUnassignMemberNumber,
    mutationKey: ['assignUnassignMemberNumber'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        onErrorFn();
        return toastEmitter('error', responseData?.error?.message);
      }
      onSuccessFn();
      queryclient.invalidateQueries('getDIDListing');
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
